<script>
  // components
  import ResultsListRow from './ResultsListRow.svelte';

  /**
   * A readable Svelte store of an individual Race.
   *
   * @type {import('../types.d').ReadableRace}
   */
  export let race;

  /**
   * @type {Map<string, import('../types.d').Crosswalk>}
   */
  export let crosswalk;

  $: totalVotes = $race.total_votes;

</script>

<ol class="candidates-list">
  {#each $race.candidates as candidate, idx (candidate.ap_id)}
    <li
      class="candidates-list-item"
      class:candidates-list-item--results-in={totalVotes > 0}
      class:candidates-list-item--winner={ candidate.is_winner == true}
      class:candidates-list-item--runoff={ candidate.is_runoff == true}>
      <ResultsListRow
        {candidate}
        lookup={crosswalk.get(candidate.ap_id)}
        {totalVotes}
      />
    </li>
  {/each}
</ol>
